import axios from 'axios';
import router from '../router';

const state = {
// users state
  labels: []
};

const mutations = {
// users mutations
    SET_LABELS(state, labels) {
        state.labels = labels;
    }
};

const actions = {
  async fetchLabels({ commit }, { search }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
        throw new Error('No token found'); // Handle absence of token
    }
    
    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/labels`, {
            headers: { Authorization: `Bearer ${userToken}` },
            params: { search } // Include search parameter in request
        });
        commit('SET_LABELS', response.data); // Update Vuex store with users
    } catch (error) {
        console.error('Error fetching products:', error); // Log any errors
        throw error; // Handle error in your components
    }
  },
  async getLabelByID({ commit }, labelId) { // Change from destructuring to direct variable
    console.log('Fetching label with ID:', labelId);
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
        router.push({ name: 'login' });
        return;
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/labels/${labelId}`, {
            headers: { Authorization: `Bearer ${userToken}` }
        });
        console.log('Label fetch response:', response.data);
        commit('SET_LABELS', response.data);
    } catch (error) {
        console.error('Error fetching label:', error);
        throw error;
    }
  },
  async createLabel({ dispatch }, { label }) {
    console.log('Creating label:', label);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.post(`${baseUrl}/labels`, label,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('Label created:', label);
      dispatch('fetchLabels', { search: '' });
    } catch (error) {
      console.error('Error creating label:', error);
      throw error; // Rethrow the error to handle it in the component
    }
  },
  async updateLabel({ dispatch }, { label }) {
    console.log('Updating label:', label);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.put(`${baseUrl}/labels/${label.id}`, label,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('Label updated:', label);
      dispatch('fetchLabels', { search: '' });
    } catch (error) {
      console.error('Error updating label:', error);
      throw error; // Rethrow the error to handle it in the component
    }
  },
  async deleteLabel({ dispatch }, { label }) {
    console.log('Deleting label:', label);
    const userToken = localStorage.getItem('userToken');
    console.log('User token:', userToken);
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.delete(`${baseUrl}/api/labels/${label}`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('Label deleted:', label);
      dispatch('fetchLabels', { search: '' });
    } catch (error) {
      console.error('Error deleting label:', error);
      throw error; // Rethrow the error to handle it in the component
    }
  }  
};

const getters = {
// users getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};